import React from "react";

export const GenericDataTableContext = React.createContext({
  suppressActionTypes: [],
  suppressDisabledActionTypes: [],
});
